import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getShutDown = async (start_date, end_date) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/tracker/shutdown/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          start_date,
          end_date,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Shut down data fetch error:", error);
    throw error;
  }
};

const addManualShutDown = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/tracker/shutdown/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const getVehiclebyId = async (source_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicle_score/`,
      {
        params: {
          source_id: source_id,
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

export { getShutDown, addManualShutDown, getVehiclebyId };
